import React, { memo, useState } from "react";
import CustomerSource from "../CustomerSource";
import ProfilePhoto from "../ProfilePhoto";
import { AccountCircleOutlined, Menu } from "@mui/icons-material";
import { conversationMenuMobileToggle } from "../../utils";
import { Conversation } from "../../store/slices/conversationsSlice";
import Button from "../Button";
import AssignToAgent from "../Dialog/AssignToAgent";
import { useTranslation } from "react-i18next";

type Props = {
  conversation: Conversation;
};
const ChatHeader: React.FC<Props> = ({ conversation }) => {
  const { t } = useTranslation();
  const [assignToAgentDialog, setAssignToAgentDialog] = useState(false);
  return (
    <div className="bg-white py-2 px-5 border-b-2 flex items-center justify-between min-h-[74px] max-h-[74px]">
      {assignToAgentDialog ? (
        <AssignToAgent
          customerId={conversation.customer._id}
          closeDialog={() => setAssignToAgentDialog(false)}
        />
      ) : null}
      <div className="flex items-center">
        <button className="lg:hidden" onClick={conversationMenuMobileToggle}>
          <Menu className="text-gray-700 me-2" />
        </button>
        <ProfilePhoto
          name={conversation.customer.name}
          photoUrl={conversation.customer.photoUrl}
        />
        <div className="ms-2 w-fit flex flex-col">
          <h3 className="font-bold text-sm">
            {conversation.customer.name.slice(0, 27)}
          </h3>
          <div className="flex items-center">
            <CustomerSource source={conversation.source} />
          </div>
        </div>
      </div>
      {conversation.source !== "phone" ? (
        <Button
          title={
            <>
              <AccountCircleOutlined className="md:me-2" />
              <span className="hidden md:block">{t("assign_to_agent")}</span>
            </>
          }
          size="sm"
          type="button"
          className="w-fit"
          onClick={() => setAssignToAgentDialog(true)}
        />
      ) : null}
    </div>
  );
};

export default memo(ChatHeader);
